import React from "react";
import { FaBrain, FaUserFriends, FaGift } from "react-icons/fa";

const OurImpact = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16 bg-white">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-3xl font-extrabold text-slate-900">Our Impact</h2>
        <p className="mt-4 text-slate-600 text-lg leading-relaxed">
          Transforming education through AI-powered learning solutions that adapt to every child's unique needs.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
        <div className="bg-white rounded-xl p-8 shadow-lg flex flex-col items-center text-center">
          <div className="bg-blue-100 p-5 rounded-full mb-6">
            <FaBrain className="text-blue-600 text-3xl" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-3">AI-Powered Learning</h3>
          <p className="text-slate-600 text-base leading-relaxed">
            Personalized education paths adapted to each student's unique learning style and pace, ensuring optimal growth.
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg flex flex-col items-center text-center">
          <div className="bg-yellow-100 p-5 rounded-full mb-6">
            <FaUserFriends className="text-yellow-400 text-3xl" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-3">Community Impact</h3>
          <p className="text-slate-600 text-base leading-relaxed">
            Partnering with schools and NGOs to reach children in underserved communities and bridge the digital divide.
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg flex flex-col items-center text-center">
          <div className="bg-blue-100 p-5 rounded-full mb-6">
            <FaGift className="text-blue-600 text-3xl" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-3">Free Access</h3>
          <p className="text-slate-600 text-base leading-relaxed">
            Providing our platform at no cost to eligible organizations and students, making quality education accessible.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurImpact;